:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.range-software-registration {
  position: relative;
  height: 0;
  padding: 30px 0 65%;
  overflow: hidden;
  margin: 0 auto;
}

.range-software-registration__iframe {
  border: 1px solid #ededed;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin-top: 25px;
}

:host(:not([dir="rtl"])) .range-software-registration__iframe {
  left: 0;
}

:host([dir="rtl"]) .range-software-registration__iframe {
  right: 0;
}